<div class="wrapper">
		<header class="header" [ngClass]="{'is-active':expand}">
			<div class="shell">
				<a routerlink="main" class="logo">
					<img src="assets/images/FourFactors_logo.png" alt="FourFactorsLogo" />
				</a>

				<a  (click)=toggleHeader() class="btn-burger"  >
					<span></span>
					
					<span></span>
					
					<span></span>
				</a>

				<nav class="nav">
					<ul>
						<li [ngClass]="{'is-active':CS.current_page=='aboutus'}">
							<a (click)="CS.current_page='aboutus';" routerlink="/aboutus" href="/aboutus">About Us</a>
						</li>

						<li [ngClass]="{'is-active':CS.current_page=='main'}">
							<a (click)="CS.current_page='main'" routerlink="/main" href="/main">Explore Hx TrustID<sup>&trade;</sup></a>
						</li>

						<li [ngClass]="{'is-active':CS.current_page=='contactus'}">
							<a (click)="CS.current_page='contactus'" routerlink="/contactus" href="/contactus">Contact Us</a>
						</li>
					</ul>
				</nav><!-- /.nav -->
			</div><!-- /.shell -->
		</header><!-- /.header -->
  <router-outlet></router-outlet>
	</div>